import React from "react";
import Link from "gatsby-link";
import PropTypes from "prop-types";

import FaBolt from "react-icons/lib/fa/bolt";
import FaDrop from "react-icons/lib/fa/tint";
import FaLeaf from "react-icons/lib/fa/leaf";
import FaHome from "react-icons/lib/fa/home";
import FaRocket from "react-icons/lib/fa/rocket";
import FaBomb from "react-icons/lib/fa/bomb";

import pic01 from '../../media/images/1_Colonize_2208x1242.png'
import pic02 from '../../media/images/2_Train_2208x1242.png'
import pic03 from '../../media/images/3_Visit_2208x1242.png'
import pic04 from '../../media/images/4_Defend_2208x1242.png'

import FeatureGraphic from '../../media/images/feature_graphic.jpg'

import IconStoreApple from '../../media/images/store_apple.png'
import IconStoreGoogle from '../../media/images/store_google.svg'

const Hero = props => {
  const { scrollToContent, backgrounds, theme } = props;

  return (
    <React.Fragment>


            <div>
                <section>
                    <img src={FeatureGraphic} width="100%"/>
                </section>

                <section id="one" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-6">
                            <header className="major">
                                <h2>The research on human behaviour where scarcity rules</h2>
                            </header>
                            <p>We are proud to announce Mars Race, a game that has been in development the past three years. By a team of ten working all hours of the day to realize a dream to go beyond the stars.</p>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <iframe className="image fit" src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fthe.marsrace%2Fvideos%2F455011954955467%2F&show_text=0&width=560" width="560" height="315" allowFullScreen="true"></iframe>
                            </span>
                        </div>
                    </div>
                </section>

                <section id="two" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-6">
                            <ul className="major-icons">
                                <li><span className="icon style1 major"><span><FaBolt size={78} color="#eecbb8"/></span></span></li>
                                <li><span className="icon style2 major"><span><FaDrop size={78} color="#eab69e"/></span></span></li>
                                <li><span className="icon style3 major"><span><FaLeaf size={78} color="#e2aa91"/></span></span></li>
                                <li><span className="icon style4 major"><span><FaHome size={78} color="#de926e"/></span></span></li>
                                <li><span className="icon style5 major"><span><FaRocket size={78} color="#d87e57"/></span></span></li>
                                <li><span className="icon style6 major"><span><FaBomb size={78} color="#cd5f34"/></span></span></li>
                            </ul>
                        </div>
                        <div className="col-6">
                            <header className="major">
                                <h2>As close as it gets</h2>
                            </header>
                            <p>Game uses real world nomenclatures as defined by USGS Planetary Nomenclature association. It is time you pick your Martian home. You will be in charge of generating electicity, gathering water to produce fuel. And finnaly make you own greenhouse for food production.</p>
                            <p>To assist you in this task you will need to create the first intelligent martian life. Artificial intelligence will be the primary driving force for your success. Upgrading and training these for gathering resources will be their primary function. While you make sure that the base is running smoothly.</p>
                            <p>Conflicts will occur where struggle for survival is the key.</p>
                        </div>
                    </div>
                </section>

                <section id="three" className="main style1 special">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>Martians Daily Routine</h2>
                            </header>
                            <p>The hard facts of living in a wasteland of scarcity and cruel nature of life.</p>
                        </div>

                        <div className="col-3">
                            <span className="image fit"><img src={pic01} alt="" /></span>
                            <h3>Stake Your Claim</h3>
                            <p>Build a new civilization on Mars for future generations. Harvest the power of the sun and generate electricity. Mine for water by beaming microwaves at the soil and extracting the water vapor so you can generate fuel and build green houses.</p>
                        </div>
                        <div className="col-3">
                            <span className="image fit"><img src={pic02} alt="" /></span>
                            <h3>Generation Robot</h3>
                            <p>Civilization on Mars will be fully automated with next generation robots. With artificial intelligence as leading technology we can simplify maintainance and management</p>
                        </div>
                        <div className="col-3">
                            <span className="image fit"><img src={pic03} alt="" /></span>
                            <h3>Recyling at any Cost</h3>
                            <p>Important resources like electricity, water, fuel and oxygen will be the sought after by everyone. Any recycling method will do.</p>
                        </div>
                        <div className="col-3">
                            <span className="image fit"><img src={pic04} alt="" /></span>
                            <h3>Protect Resources</h3>
                            <p>In the harsh Martian environment life is going to be hard. Be it for human or mechanical. Here robots rule the world. Place defences strategically.</p>
                        </div>                        

                    </div>
                </section>

                <section id="four" className="main style2 special">
                    <div className="container">
                        <header className="major">
                            <h2>The humanity of it all</h2>
                        </header>
                        <div>
                            <a href="https://itunes.apple.com/us/app/mars-race/id1296888245?ls=1&mt=8" target="itunes"><img src={IconStoreApple} height="60px"/></a>
                            <a href="https://play.google.com/store/apps/details?id=com.agc.ubgclient" target="google_play"><img src={IconStoreGoogle} height="60px"/></a>
                        </div>
                        <p><i><Link to={`/mars_life/`} activeClassName="active">We aim to use some of the funds collected to reasearch how to grow food in harsh conditions.</Link></i></p>
                    </div>
                </section>
            </div>    


    </React.Fragment>
  );
};

Hero.propTypes = {
  scrollToContent: PropTypes.func.isRequired,
  backgrounds: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default Hero;


// WEBPACK FOOTER //
// ./src/components/Hero/Hero.js